import { MemberManagementMenu } from './MemberManagementMenu';
import { ActionMenu } from '~/components/ui/ActionMenu';
import { allOrganizationUserRoles, type OrganizationUserRoles } from '~/types/organization';
import type { OrganizationData } from '~/types/organization';
import { plural } from '~/utils/plural';

interface SelectionToolbarProps {
  selectedCount: number;
  onRolesChange: (role: OrganizationUserRoles) => void;
  organization: OrganizationData;
}

export const MemberSelectionToolbar = ({ selectedCount, onRolesChange, organization }: SelectionToolbarProps) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="relative flex gap-2 items-center px-3 py-2 rounded-md border border-bolt-ds-brand h-11">
      <span className="grow-1 text-sm text-bolt-ds-brand font-semibold">
        {selectedCount} {plural(selectedCount, 'user')} selected
      </span>
      <div className="flex gap-6 absolute right-3 top-2.5">
        <ActionMenu
          triggerNode={
            <div className="flex gap-1 text-bolt-elements-textPrimary items-center">
              Change rights <span className="i-ph:caret-down" />
            </div>
          }
          items={allOrganizationUserRoles.map((role) => ({
            label: role.replaceAll('_', ' '),
            id: role,
            onAction: (role) => {
              onRolesChange(role);
            },
          }))}
          triggerClassName="p-0 bg-transparent"
          contentClassName="capitalize"
        />
        <MemberManagementMenu organization={organization} needTierChange />
      </div>
    </div>
  );
};
